import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getPreferredLanguage } from 'src/shared/helpers/getPreferredLanguage';

import { getUserInformation } from '../selectors/userSelectors';

export const LanguagePreferenceListener: React.FC = () => {
    const { i18n } = useTranslation();
    const { languagePreferences } = useSelector(getUserInformation);

    const setMomentLocale = (language: string) => {
        moment.locale(language === 'zh-Hans' ? 'zh-CN' : language);
    };

    useEffect(() => {
        setMomentLocale(i18n.language);
    }, []);

    useEffect(() => {
        if (languagePreferences?.length) {
            const language = getPreferredLanguage(languagePreferences[0]);

            i18n.changeLanguage(language);
            setMomentLocale(language);
        }
    }, [languagePreferences]);

    return null;
};
